import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { WallGallery } from "@/components/site/home/WallGallery";
import { useHeroText } from "@/lib/site";

export const HeroBlock = () => {
  const text = useHeroText();
  return (
    <section data-testid="hero-section" aria-labelledby="hero-title" className="relative h-[calc(100svh-80px)] min-h-[620px] overflow-hidden bg-[#EAE7E2] lg:h-[calc(100svh-96px)]">
      <WallGallery />
      <div data-testid="hero-text-band" aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-[40%] bg-[linear-gradient(to_top,rgba(8,8,8,0.85)_0%,rgba(8,8,8,0.72)_80%,rgba(8,8,8,0)_100%)] lg:h-[36%]" />
      <div data-testid="hero-overlay" className="absolute bottom-0 left-0 max-w-[30rem] px-5 pb-6 sm:px-8 lg:max-w-[46rem] lg:px-12 lg:pb-7 xl:px-16">
        <h1 id="hero-title" data-testid="hero-headline" className="rise font-serif-display text-[24px] font-medium leading-[1.15] text-[#FAF8F4] sm:text-[28px] xl:text-[32px]">
          {text ? <>{text.title} {text.title_em && <em className="font-normal">{text.title_em}</em>}</> : <span className="invisible">LUMINA</span>}
        </h1>
        {text?.support && <p data-testid="hero-support" className="rise d1 mt-2 text-sm leading-relaxed text-[#FAF8F4]/85">{text.support}</p>}
        <Link to="/personalizar" data-testid="hero-cta-button"
          className="rise d2 group mt-4 inline-flex items-center gap-3 rounded-full bg-[#080808] px-7 py-3.5 text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-[#FAF8F4] ring-1 ring-[#FAF8F4]/25 transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#B18A4B]">
          Crea tu LUMINA <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>
    </section>
  );
};
